import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "comanda-detalii-container" }
const _hoisted_2 = {
  key: 0,
  class: "mb-2 dx-fieldset loading-state"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-2 dx-fieldset header-fields"
}
const _hoisted_4 = { class: "dx-fieldset-header" }
const _hoisted_5 = { class: "header-row" }
const _hoisted_6 = { class: "dx-field compact-field" }
const _hoisted_7 = { class: "dx-field-value" }
const _hoisted_8 = { class: "dx-field compact-field" }
const _hoisted_9 = { class: "dx-field-value" }
const _hoisted_10 = { class: "dx-field compact-field" }
const _hoisted_11 = { class: "dx-field-value" }
const _hoisted_12 = { class: "dx-field compact-field" }
const _hoisted_13 = { class: "dx-field-value" }
const _hoisted_14 = {
  key: 2,
  class: "mb-2 dx-fieldset error-state"
}

import { ref, watch } from 'vue';
import DxDataGrid, { DxColumn } from 'devextreme-vue/data-grid';
import DxTextBox from 'devextreme-vue/text-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import axios from 'axios';

// Interfață pentru datele de antet ale comenzii
interface OrderHeaderData {
    Id: number | string;
    Cod: string;
    NumeClient: string; // Presupunem numele câmpului returnat de API
    DataComenzii: string; 
    ValoareTotala: number;
    [key: string]: any; 
}

interface Props { comandaId: string }

export default /*@__PURE__*/_defineComponent({
  __name: 'GridComandaDetalii',
  props: {
    comandaId: {}
  },
  setup(__props: any) {

const props = __props;

const detaliiStore = ref<any>(null);
const comanda = ref<OrderHeaderData | null>(null);
const isLoading = ref(false); 


watch(() => props.comandaId, async (id) => {
    if(!id) return;

    isLoading.value = true;
    comanda.value = null; 
    
    const token = localStorage.getItem("ERA_Jwt");
    if (!token) {
        console.error("Token JWT lipsă.");
        isLoading.value = false;
        return;
    }

    // 1. Apel Axios pentru antet
    try {
        const urlHeader = `${AppSetting.API_Url_ComercialOdata}PRO_Comenzi(${id})`;
        const response = await axios.get<OrderHeaderData>(urlHeader, {
            headers: { "Authorization": "Bearer " + token }
        });
        comanda.value = response.data; 
    } catch (err) {
        console.error("Eroare la încărcarea antetului comenzii:", err);
    } 

    // 2. Setarea store-ului DevExtreme
    const urlDetalii = `${AppSetting.API_Url_ComercialOdata}PRO_ComenziDetalii?ComandaID=${id}`;

    detaliiStore.value = new DataSource({
        store: new ODataStore({
            url: urlDetalii,
            key:'ID',
            version:4,
            beforeSend: (e:any)=>{
                e.headers = {
                    "Content-Type":"application/json",
                    "Authorization":"Bearer "+token
                };
            }
        })
    });

    // Soluția pentru eroarea .finally()
    detaliiStore.value.load().always(() => { 
        isLoading.value = false;
    });

}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "dx-fieldset-header" }, "Se încarcă Comanda...", -1)
        ]))]))
      : (comanda.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, "Detalii Comandă (" + _toDisplayString(comanda.value.Cod) + ")", 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "dx-field-label" }, "ID Comandă:", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(DxTextBox), {
                    value: comanda.value.Id,
                    "read-only": true,
                    "styling-mode": "filled"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dx-field-label" }, "Client:", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(DxTextBox), {
                    value: comanda.value.NumeClient,
                    "read-only": true,
                    "styling-mode": "filled"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dx-field-label" }, "Data:", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(DxDateBox), {
                    value: comanda.value.DataComenzii,
                    "read-only": true,
                    "display-format": "dd.MM.yyyy",
                    "styling-mode": "filled"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dx-field-label" }, "Valoare Totală:", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(DxNumberBox), {
                    value: comanda.value.ValoareTotala,
                    "read-only": true,
                    format: "#,##0.00",
                    "styling-mode": "filled"
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]))
        : (props.comandaId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "dx-fieldset-header text-red-700" }, "Comanda nu a putut fi găsită.", -1)
            ]))]))
          : _createCommentVNode("", true),
    _createVNode(_unref(DxDataGrid), {
      "data-source": detaliiStore.value,
      "key-expr": "ID",
      "show-borders": "",
      "column-auto-width": true,
      "allow-column-reordering": true,
      scrolling: { mode: 'virtual' },
      "filter-row": { visible: true },
      paging: { pageSize: 20 },
      height: "auto",
      class: "detalii-grid"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DxColumn), {
          "data-field": "ProdusCodCPV",
          caption: "Cod CPV",
          width: "120"
        }),
        _createVNode(_unref(DxColumn), {
          "data-field": "ProdusNume",
          caption: "Produs",
          width: "200"
        }),
        _createVNode(_unref(DxColumn), {
          "data-field": "Cantitate",
          caption: "Cantitate",
          "data-type": "number",
          width: "100"
        }),
        _createVNode(_unref(DxColumn), {
          "data-field": "PretNegociat",
          caption: "Preț negociat",
          "data-type": "number",
          format: "#0.00",
          width: "120"
        }),
        _createVNode(_unref(DxColumn), {
          "data-field": "Valoare",
          caption: "Valoare",
          "data-type": "number",
          format: "#0.00",
          width: "120"
        }),
        _createVNode(_unref(DxColumn), {
          "data-field": "TermenLivrare",
          caption: "Termen Livrare",
          "data-type": "date",
          width: "120"
        })
      ]),
      _: 1
    }, 8, ["data-source"])
  ]))
}
}

})